import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimFlyInChars } from '@readdy/anim/header/fly-in-chars/react';
import DestinationSearch from './DestinationSearch';

export default function Hero() {
  const { t } = useTranslation();
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <>
      <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20Vietnam%20landscape%20with%20cascading%20emerald%20rice%20terraces%20on%20green%20hills%20under%20warm%20golden%20sunlight%2C%20a%20local%20farmer%20in%20a%20conical%20hat%20walking%20along%20a%20winding%20path%2C%20distant%20limestone%20karst%20mountains%20and%20soft%20mist%2C%20cinematic%20travel%20photography%2C%20rich%20saturated%20colors%2C%20warm%20inviting%20tones%2C%20high%20detail&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
          alt={t('hero.alt')}
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pb-12 md:pb-16">
          <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-5">
            {t('hero.support')}
          </p>
          {prefersReducedMotion ? (
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.2] mb-10">
              {t('hero.title').split('\n').map((line, i, arr) => (
                <span key={i} className={`block ${i < arr.length - 1 ? 'mb-2 md:mb-3' : ''}`}>
                  {line}
                </span>
              ))}
            </h1>
          ) : (
            <AnimFlyInChars stagger={45}>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.2] mb-10">
                {t('hero.title').split('\n').map((line, i, arr) => (
                  <span key={i} className={`block ${i < arr.length - 1 ? 'mb-2 md:mb-3' : ''}`}>
                    {line}
                  </span>
                ))}
              </h1>
            </AnimFlyInChars>
          )}
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-loose mb-8">
            {t('hero.subtitle')}
          </p>
          <div className="mt-12 flex items-center justify-center">
            <a
              href="#tours"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('hero.exploreTours')}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-white">
        <div className="flex flex-col items-center gap-4">
          <h2 className="font-heading text-lg md:text-2xl font-bold text-secondary-900 text-center">
            {t('hero.whereNext')}
          </h2>
          <DestinationSearch />
        </div>
      </section>
    </>
  );
}